import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/who-we-help")({
  component: () => <Outlet />,
});
